import { showInfoModal } from "./modal";
import { fetch } from "@/utilities";
import { html } from "lit";
import { I18n } from "@/i18n/i18n";

export function showInlineFile(name: string, content: string): void {
    showInfoModal(name, html`<div class="code">${content}</div>`);
}

export async function showRealFile(name: string, activityPath: string, filePath: string): Promise<void> {
    const path = activityPath + "/" + filePath;
    const random = Math.floor(Math.random() * 10000 + 1);
    showInfoModal(
        name,
        html`<div class="code" id="file-${random}">Loading...</div>`,
        html`<a
            href="${path}"
            class="btn btn-icon btn-icon-muted"
            title="${I18n.t("js.download")}"
            aria-label="${I18n.t("js.download")}"
            download
        >
            <i class="mdi mdi-download" aria-hidden="true"></i>
        </a>`,
    );

    const response = await fetch(path, {
        method: "GET",
    });
    const data = await response.text();
    let lines = data.split("\n");
    const maxLines = 99;
    if (lines.length > maxLines) {
        lines = lines.slice(0, maxLines);
        lines.push("...");
    }

    const table = document.createElement("table");
    table.className = "external-file";
    for (let i = 0; i < lines.length; i++) {
        const tr = document.createElement("tr");

        const number = document.createElement("td");
        number.className = "line-nr";
        number.textContent = i === maxLines ? "" : (i + 1).toString();
        tr.appendChild(number);

        const line = document.createElement("td");
        line.className = "line";
        // textContent is safe, html is not executed
        line.textContent = lines[i];
        tr.appendChild(line);
        table.appendChild(tr);
    }
    const fileView = document.getElementById(`file-${random}`);
    fileView.innerHTML = "";
    fileView.appendChild(table);
}
